import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { baseUrl } from './api-config';
import { Incarico } from '../models/incarico';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators'
import { WorkflowStep } from '../models/workflow-step';



@Injectable({
    providedIn: 'root'
})
export class WorkflowService {
    constructor(private http: HttpClient) {
    }

    getWorkflowStepDetails(stepId: number, ids: number[] = [], opts: { scope?: 'mine'|'studio' } = {}): Observable<Incarico[]> {
        const params: any = {};
        if (opts?.scope) params.scope = opts.scope;
        ids.forEach((id, idx) => params[`ids[${idx}]`] = id);
        return this.http.get<any>(`${baseUrl}/workflow/step/${stepId}/details`, { params }).pipe(
            map((response: any) => {
                const arr = Array.isArray(response) ? response : (response?.data ?? []);
                return (arr || []).map((v: any) => new Incarico().deserialize(v));
            })
        );
    }

    getWorkflow(searchParams = {}, id, opts: { mode?: 'light'|'ultra', scope?: 'mine'|'studio', resource?: 'card' } = {}): Observable<WorkflowStep[]> {
        const params: any = { "search": JSON.stringify(searchParams) };
        if (opts?.mode) params.mode = opts.mode;
        if (opts?.scope) params.scope = opts.scope;
        if (opts?.resource) params.resource = opts.resource;
        return this.http.get<any>(`${baseUrl}/workflow`, { params }).pipe(
            map((response: any) => {
                const arr = Array.isArray(response) ? response : (response?.data ?? []);
                return (arr || []).map((v: any) => new WorkflowStep().deserialize(v));
            })
        )
    }

    removeFromList(incarico: Incarico, workflowStep: WorkflowStep): Promise<any> {
        return this.http.post<any>(`${baseUrl}/workflow/remove`, { incarico: incarico?.id, workflow_step: workflowStep?.id }).toPromise();
    }

    addToList(incarico: Incarico, workflowStep: WorkflowStep): Promise<any> {
        return this.http.post<any>(`${baseUrl}/workflow/add`, { incarico: incarico?.id, workflow_step: workflowStep?.id }).toPromise();
    }

    getWorkflowDaEvadereCount(): Observable<Number> {
        return this.http.get<any>(`${baseUrl}/workflow/da-evadere/count`);
    }

    getWorkflowDaControllareCount(): Observable<Number> {
        return this.http.get<any>(`${baseUrl}/workflow/da-controllare/count`);
    }

    updateWorkflowStep(stepId: number, payload: Partial<WorkflowStep>): Promise<WorkflowStep> {
        return this.http.patch<any>(`${baseUrl}/workflow-steps/${stepId}`, payload).pipe(
            map((response: any) => new WorkflowStep().deserialize(response))
        ).toPromise();
    }
}
